import shave from 'shave'
import $ from 'jquery'
import {Swiper, Pagination, Navigation, Autoplay} from 'swiper/js/swiper.esm.js';
Swiper.use([Pagination, Navigation, Autoplay]);

shave('.lawyer-excerpt', 70);

var numSlides = $('.swiper-lawyers .swiper-slide').length;

switch (numSlides) {
    case 1:
        var breakPoints = {};
        break;
    case 2:
        var breakPoints = {
            850: {
                slidesPerView: 2
            }
        };
        break;
    case 3:
        var breakPoints = {
            850: {
                slidesPerView: 2
            },
            992: {
                slidesPerView: 3
            }
        };
        break;
    default:
        var breakPoints = {
            850: {
                slidesPerView: 2
            },
            992: {
                slidesPerView: 3
            },
            1200: {
                slidesPerView: 4
            }
        };
        break;
}

const lawyerSwiper = new Swiper('.swiper-lawyers', {
    autoHeight: true,
    autoplay: true,
    slidesPerView: 1,
    spaceBetween: 30,
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: breakPoints
});
